import { constants } from '@bingads-webui/instrumentation';
import { Filter } from '@bingads-webui/listener';
import type { InstrumentationLog } from '../types';

export class ConsoleFilter extends Filter {
  check(logMessage: InstrumentationLog) {
    const category = logMessage.logCategory || '';
    const api = logMessage.api || '';

    // log only error logs from window.onerror
    if (api === 'onerror' && category === constants.LOGCATEGORY.ERROR) {
      return false;
    }

    return true;
  }
}
